import clsx from 'clsx';

export const Panel = ({ category = 'default', height = 'full', title, children, className, noPadding }) => {
  const getBackgroundColor = () => {
    if (category === 'default') {
      return 'bg-perception-black-800';
    } else if (category === 'main') {
      return 'bg-perception-black-900';
    } else if (category === 'secondary') {
      return 'bg-perception-black-500';
    }
  };

  const getHeight = () => {
    if (height === 'full') {
      return 'h-full';
    }
    else {
      return height;
    }
  }

  return (
    <div className={clsx('panel', getBackgroundColor(), getHeight(), 'flex flex-col w-full relative overflow-y-auto', className)}>
      <HeaderPanel title={title} />
      <div className={`${noPadding ? '' : 'py-4 px-4'} h-full w-full flex flex-col text-perception-gray-500 overflow-y-auto`}>{children}</div>
    </div>
  );
};

const HeaderPanel = ({ title }) => {
  return (
    <div className='bg-perception-gray-800 flex pl-4 py-[0.15rem] w-full'>
      <span className='text-white text-xs'>{title}</span>
    </div>
  );
};
